import {ExperimentsConfig} from '../types'

export const FORCE_PREFIX = 'ab_'

export const {experiments, features} =
  /**
   * Dynamically imports the experiments and features configuration from the root config directory.
   */
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('../../../../../config/experiments') as {
    experiments: ExperimentsConfig
    features: ExperimentsConfig
  }

const combinedExperiments = {
  ...experiments,
  ...features
}

/**
 * Combined object containing all experiments and features.
 * @param experiments - The experiments config object.
 * @returns The combined object containing all experiments and features.
 */
export const reduceExperiments = (experiments: ExperimentsConfig) =>
  Object.keys(experiments).reduce(
    (acc, key) => ({
      ...acc,
      [key]: typeof experiments[key] === 'string' ? experiments[key] : 'a'
    }),
    {} as Record<string, string | null>
  )

/**
 * The experiments config values mapped to boolean values.
 */
export const booleanTogglesConfig = reduceExperiments(combinedExperiments)
